import { useShowResponseStatus } from '@/shared';
import { useRefreshConversionPairMutation } from '../store/conversion-pairs-api';
import { handleConversionPairError } from '../utils/helpers/conversion-pairs-errors';

import type { TConversionPair } from '../store/types';

export const useRefreshConversionPair = () => {
  const [refreshConversionPair, { isLoading, isSuccess, error }] = useRefreshConversionPairMutation();
  const refreshError = handleConversionPairError(error);

  useShowResponseStatus({
    isSuccess,
    successMessage: 'Курс торговой пары успешно обновлён',
    error: refreshError,
  });

  const handleRefresh = async (item: TConversionPair) => {
    await refreshConversionPair({ pairId: item.id });
  };

  return {
    isLoading,
    handleRefresh,
  };
};
